<template>
  <div class="equipment-rhlist">
    <h2 class="top-title">点表管理</h2>
    <!-- <Card dis-hover> -->
    <ul class="common-search li-margin">
      <li>
        <span>指标名称: </span>
        <Input
          v-model="dataForm.name"
          @on-search="(e) => searchInput(e, 'name')"
          search
          name="name"
          placeholder="请输入"
        />
      </li>
      <li>
        <span>属性名称: </span>
        <Input
          v-model="dataForm.functionName"
          @on-search="(e) => searchInput(e, 'functionName')"
          search
          name="functionName"
          placeholder="请输入"
        />
      </li>
      <li>
        <span>属性编码: </span>
        <Input
          v-model="dataForm.identifier"
          @on-search="(e) => searchInput(e, 'identifier')"
          search
          name="identifier"
          placeholder="请输入"
        />
      </li>
      <li>
        <span>指标组: </span>
        <Select
          v-model="dataForm.line"
          @on-change="(e) => changeSel(e, 'line', groupOption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="type.value"
            :value="type.value"
            v-for="type in groupOption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>

      <li>
        <span>阈值: </span>
        <Select
          v-model="dataForm.secureLine"
          @on-change="(e) => changeSel(e, 'secureLine', thresholdLineoption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="key"
            :value="type.value"
            v-for="(type, key) in thresholdLineoption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>
      <li>
        <span>波动: </span>
        <Select
          v-model="dataForm.isFluctuate"
          @on-change="(e) => changeSel(e, 'isFluctuate', radioOption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="key"
            :value="type.value"
            v-for="(type, key) in radioOption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>

      <li>
        <span>动态阈值: </span>
        <Select
          v-model="dataForm.thresholdLine"
          @on-change="(e) => changeSel(e, 'thresholdLine', radioOption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="key"
            :value="type.value"
            v-for="(type, key) in radioOption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>

      <li>
        <span>单调性: </span>
        <Select
          v-model="dataForm.isMonotonicity"
          @on-change="(e) => changeSel(e, 'isMonotonicity', radioOption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="key"
            :value="type.value"
            v-for="(type, key) in radioOption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>
      <li>
        <span>质量位: </span>
        <Select
          v-model="dataForm.isQuality"
          @on-change="(e) => changeSel(e, 'isQuality', radioOption)"
          :clearable="true"
          placeholder="全部"
        >
          <Option
            :key="key"
            :value="type.value"
            v-for="(type, key) in radioOption"
            >{{ type.lable }}</Option
          >
        </Select>
      </li>

      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle"
      /></span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="common-list list-margin">
      <!-- 美孚管理员 -->
      <Button
        v-nohasPermi="['m3', 'm4']"
        type="primary"
        id="mdadd"
        @click="added()"
        v-if="userRole.indexOf('m') > -1 || userRole.includes('c1')"
      >
        <Icon type="md-add" /> 新增点表
      </Button>
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <!-- 分页器 -->
      <div class="common-page fr" id="rhlistPage" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getLists"
          @on-page-size-change="getListsSize"
        >
        </Page>
      </div>
    </div>
    <!-- </Card> -->
    <PointtDrawer
      :groupOption="groupOption"
      :colorOption="colorOption"
      :utilOption="utilOption"
      :cityList="cityList"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :timernum="timernum"
      :imageOption="imageOption"
      :init="init"
      :thresholdLineoption="thresholdLineoption"
    >
    </PointtDrawer>
    <prointMdoel
      @change="changeMethods"
      :formData="formData"
      v-model="modelShow"
    />
    <Modal
      class="newModal"
      v-model="QualityShow"
      title="修改质量位"
      width="1000"
      :mask-closable="false"
      @on-cancel="cacel"
      class-name="vertical-center-modal"
    >
      <Form ref="formValidate" :model="formData" label-position="top">
        <Col span="24">
          <FormItem
            label="是否有质量位"
            prop="
          "
          >
            <RadioGroup v-model="formData.isQuality">
              <Radio :label="1">
                <span>是</span>
              </Radio>
              <Radio :label="0">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="24" v-if="formData.isQuality == 1">
          <FormItem label="质量位详情" prop="qualitys">
            <div @click="modelShow = true" class="pointemitfont">编辑</div>
            <template v-if="formData.qualitys">
              <template v-if="!$c.isEmptyObject(formData.qualitys)">
                <div
                  class="u-flex"
                  style="margin-bottom: 10px"
                  v-for="(index, key) in formData.qualitys"
                  :key="key"
                >
                  <div style="margin-right: 20px">{{ key }}</div>
                  <Input disabled :value="index" placeholder="请输入" />
                </div>
              </template>
            </template>
          </FormItem>
        </Col>
      </Form>
      <div class="drawer-footer" slot="footer">
        <Button type="primary" @click="QualityForm()">提交</Button>
        <Button style="margin-right: 8px" @click="cacel">取消</Button>
      </div>
    </Modal>
    <Modal
      class="newModal"
      v-model="iconvisible"
      title="修改图标"
      width="500"
      :mask-closable="false"
      @on-cancel="cacel"
      class-name="vertical-center-modal"
    >
      <Form ref="formValidate" :model="formData" label-position="top">
        <Col span="24">
          <FormItem label="图标" prop="isMonotonicity">
            <Poptip
              v-model="iconPopvisible"
              :confirm="false"
              placement="bottom"
              trigger="click"
            >
              <Input
                style="width: 400px"
                v-model="formData.keyname"
                placeholder="请输入"
              ></Input>
              <div slot="content" class="poptip" style="width: 400px">
                <div
                  @click="iconChange(indx)"
                  class="pot"
                  v-for="(indx, key) in imageOption"
                  :key="key"
                >
                  <div class="u-flex">
                    <div style="margin-right: 10px; width: 80px">
                      {{ indx.key }}
                    </div>
                    <img :src="indx.iconNormalFullPath" />
                    <img :src="indx.iconAbnormalFullPath" />
                    <img :src="indx.iconAlarmFullPath" />
                  </div>
                </div>
              </div>
            </Poptip>
          </FormItem>
        </Col>
      </Form>
      <div class="drawer-footer" slot="footer">
        <Button type="primary" @click="QualityForm()">提交</Button>
        <Button style="margin-right: 8px" @click="cacel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import PointtDrawer from "./components/poinrlist-drawer.vue";
import Aramcinfig from "./components/rhlist-aramcinfig.vue";
import sizeData from "@/mixins/sizeData";
import toRoleName from "@/mixins/roleName";
import { oilSiteGetList, relatedInfo, sockedDel } from "@/api/business/rhlist";
import {
  siteidentifiergetPage,
  identifierIconDelete,
  identifierIconUpdate,
  identifierIcon,
  oliSiteIdefierUntis,
  oliSiteIdefierColos,
} from "@/api/business/pointList";
import prointMdoel from "./components/proint-model.vue";
import { olitypelist } from "@/api/knowledge/device.js";
import RhlistVisible from "./components/rhlistVisible.vue";
import qdcropper from "@/components/qd-cropper/index.vue";
import Base64 from "@/util/encryptlong";
import img from "@/assets/images/wh.png";

const registerTypeList = [
  {
    label: 'Coils',
    value: '0'
  },
  {
    label: 'Input Discrete',
    value: '1'
  },
  {
    label: 'Input Registers',
    value: '3'
  },
  {
    label: 'Holding Registers',
    value: '4'
  },
];
const byteOrderList = [
  {
    label: 'ABCD',
    value: '1'
  },
  {
    label: 'BADC',
    value: '2'
  },
  {
    label: 'CDAB',
    value: '3'
  },
  {
    label: 'DCBA',
    value: '4'
  },
];

export default {
  name: "poinrilist",
  mixins: [handleSelItem, sizeData, toRoleName],
  components: {
    PointtDrawer,
    Aramcinfig,
    RhlistVisible,
    qdcropper,
    prointMdoel,
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
      sockedlist: (state) => state.pub.sockedlist,
    }),
  },
  data() {
    return {
      radioOption: [
        {
          value: 1,
          lable: "是",
        },
        {
          value: 0,
          lable: "否",
        },
      ],
      thresholdLineoption: [
        {
          value: "无",
          lable: "无",
        },
        {
          value: "下限",
          lable: "下限",
        },
        {
          value: "上限",
          lable: "上限",
        },
        {
          value: "上下限",
          lable: "上下限",
        },
      ],
      groupOption: [
        {
          value: "1",
          lable: "第1组：油温、黏度、密度",
        },
        {
          value: "2",
          lable: "第2组：水分、介电常数",
        },
        {
          value: "3",
          lable: "第3组：清洁度",
        },
        {
          value: "4",
          lable: "第4组：颗粒数",
        },
        {
          value: "5",
          lable: "第5组：油温、黏度、密度",
        },
        {
          value: "6",
          lable: "第6组：其它",
        },
      ],
      imageOption: [],
      QualityShow: false,
      formData: {},
      modelShow: false,
      groupAuthorityString: "",
      cityList: [],
      oilSiteId: "",
      visiblesShow: false,
      cid: "",
      armode1: false,
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      vicopy: false,
      visible: false,
      modeobj: {
        oilSiteTypeId: "",
        oilSiteIotName: "",
        secret: "",
      },
      modal1: false,
      userRole: ls.get("userRole"),

      dataLists: [],
      selItems: [],
      dataForm: {},
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      showDrawer: false,
      curItemDetail: {},
      selItems: [],
      dataColumn: [
        {
          title: "序号",
          type: "index",
          width: 80,

          fixed: "left",
        },
        {
          title: "指标名称",
          key: "name",
          fixed: "left",
          width: 150,
          render: (h, params) => {
            const item = params.row;
            return h(
              "div",
              {
                on: {
                  click: () => {
                    //  this.inputModel("name", params.row, "客户端展示名称");
                  },
                },
              },
              item.name || "-"
            );
          },
        },
        {
          title: "属性名称",
          key: "functionName",
          // ellipsis: true,
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h(
              "div",
              {
                style: {},
                on: {
                  click: () => {},
                },
              },
              item.functionName || "-"
            );
          },
        },
        {
          title: "英文单位",
          key: "unit",
          width: 200,
          render: (h, params) => {
            const unit = params.row.unit;
            return h(
              "div",
              {
                on: {
                  click: () => {
                    //  this.inputModel("unit", params.row, "单位");
                  },
                },
              },
              unit || "-"
            );
          },
        },
        {
          title: "中文单位",
          key: "unitName",
          width: 200,
          render: (h, params) => {
            const unitName = params.row.unitName;
            return h(
              "div",
              {
                on: {
                  click: () => {
                    //   this.inputModel("unitName", params.row, "单位名称");
                  },
                },
              },
              unitName || "-"
            );
          },
        },
        {
          title: "属性编码",
          key: "identifier",
          width: 150,

          render: (h, params) => {
            return h(
              "div",

              params.row.identifier || "-"
            );
          },
        },
        {
          title: "存储类型",
          key: "dataType",
          width: 130,
          render: (h, params) => {
            const item = params.row;
            return h(
              "div",
              {
                on: {
                  click: () => {
                    // this.SelecttModel(
                    //   "dataType",
                    //   params.row,
                    //   "指标类型",
                    //   this.dataTypeoption
                    // );
                  },
                },
              },
              item.dataType || "-"
            );
          },
        },
        {
          title: "取值范围",
          key: "dataMin",
          width: 200,
          render: (h, params) => {
            const dataMin = params.row.dataMin;
            const dataMax = params.row.dataMax;
            let text = "-";
            if (dataMin && dataMax) {
              text = dataMin + "-" + dataMax;
            } else if (dataMin) {
              text = dataMin;
            } else if (dataMax) {
              text = dataMax;
            }
            return h("div", text);
          },
        },
        {
          title: "指标组",
          key: "line",
          width: 200,
          render: (h, params) => {
            const line = params.row.line;

            return h(
              "div",
              {
                on: {
                  // click: () => {
                  //   this.inputModel("line", params.row, "指标组");
                  // },
                },
              },
              line ? this.groupOption[line - 1].lable : "-"
            );
          },
        },

        {
          title: "图标",
          key: "orderNum",
          width: 250,
          render: (h, params) => {
            let row = params.row;
            return (
              <div class="u-flex">
                <img
                  style={{ display: row.iconNormalFullPath ? "" : "none" }}
                  src={row.iconNormalFullPath}
                  class="pro-icon"
                />
                <img
                  style={{ display: row.iconAbnormalFullPath ? "" : "none" }}
                  src={row.iconAbnormalFullPath}
                  class="pro-icon"
                />
                <img
                  style={{ display: row.iconAlarmFullPath ? "" : "none" }}
                  src={row.iconAlarmFullPath}
                  class="pro-icon"
                />
              </div>
            );
          },
        },
        {
          title: "曲线颜色",
          key: "lineColor",
          width: 200,
          render: (h, params) => {
            const lineColor = params.row.lineColor;
            return h("div", {
              class: "transfer-class-name",
              style: {
                width: "18px",
                height: "18px",
                "background-color": lineColor,
              },
            });
          },
        },
        {
          title: "阈值",
          key: "secureLine",
          width: 200,
          render: (h, params) => {
            const secureLine = params.row.secureLine;
            return h(
              "div",
              {
                on: {
                  click: () => {},
                },
              },
              secureLine || "-"
            );
          },
        },
        {
          title: "动态阈值",
          key: "thresholdLine",
          width: 200,
          render: (h, params) => {
            const thresholdLine = params.row.thresholdLine;
            let text = "";
            if (thresholdLine == "无" || thresholdLine == null) {
              text = "否";
            } else {
              text = "是";
            }
            return h(
              "div",
              {
                on: {
                  click: () => {
                    // this.SelecttModel(
                    //   "thresholdLine",
                    //   params.row,
                    //   "动态阈值上下限",
                    // );
                  },
                },
              },
              text
            );
          },
        },

        {
          title: "波动计算",
          key: "isFluctuate",
          width: 200,
          render: (h, params) => {
            const isFluctuateText = params.row.isFluctuate == 0 ? "否" : "是";
            return h(
              "div",
              {
                on: {
                  click: () => {
                    /// this.readio("isFluctuate", params.row, "是否计算波动");
                  },
                },
              },
              isFluctuateText || "-"
            );
          },
        },
        {
          title: "单调性计算",
          key: "isMonotonicity",
          width: 200,
          render: (h, params) => {
            const itemText = params.row.isMonotonicity == 0 ? "否" : "是";
            return h(
              "div",
              {
                on: {
                  click: () => {
                    // this.readio("isMonotonicity", params.row, "计算单调性");
                  },
                },
              },
              itemText || "-"
            );
          },
        },
        // {
        //   title: "寄存器地址",
        //   key: "registerAddress",

        //   width: 200,
        //   render: (h, params) => {
        //     const registerAddress = params.row.registerAddress;
        //     return h(
        //       "div",
        //       {
        //         on: {
        //           click: () => {
        //             // this.inputModel(
        //             //   "registerAddress",
        //             //   params.row,
        //             //   "寄存器地址"
        //             // );
        //           },
        //         },
        //       },
        //       registerAddress || "-"
        //     );
        //   },
        // },
        {
          title: "数据类型",
          key: "pointType",
          width: 200,
          render: (h, params) => {
            const pointType = params.row.pointType;
            return h(
              "div",
              {
                on: {
                  click: () => {
                    // this.inputModel("pointType", params.row, "长度");
                  },
                },
              },
              pointType || "-"
            );
          },
        },
        {
          title: '网关寄存器类型',
          key: 'registerType',
          width: 200,
          render: (h, params) => {
            const registerType = params.row.registerType;

            return h(
              "div",
              registerType ? registerTypeList.find((item) => item.value === registerType).label : "-"
            );
          },
        },
        {
          title: '偏移量',
          key: 'offset',
          width: 200,
          render: (h, params) => {
            const offset = params.row.offset;
            return h(
              "div",
              offset || "-"
            );
          },
        },
        {
          title: '网关寄存器地址',
          key: 'address',
          width: 200,
          render: (h, params) => {
            const address = params.row.address;
            return h(
              "div",
              address || "-"
            );
          },
        },
        {
          title: '字节序',
          key: 'byteOrder',
          width: 200,
          render: (h, params) => {
            const byteOrder = params.row.byteOrder;
            return h(
              "div",
              byteOrder ? byteOrderList.find((item) => item.value === byteOrder).label : "-"
            );
          },
        },
        // {
        //   title: "读功能码",
        //   key: "readFunctionCode",
        //   width: 200,
        //   render: (h, params) => {
        //     const readFunctionCode = params.row.readFunctionCode;
        //     return h(
        //       "div",
        //       {
        //         on: {
        //           click: () => {
        //             //this.inputModel("readFunctionCode", params.row, "读功能码");
        //           },
        //         },
        //       },
        //       readFunctionCode || "-"
        //     );
        //   },
        // },
        // {
        //   title: "写功能码",
        //   key: "writeFunctionCode",
        //   width: 200,
        //   render: (h, params) => {
        //     const writeFunctionCode = params.row.writeFunctionCode;
        //     return h(
        //       "div",
        //       {
        //         on: {
        //           click: () => {
        //             // this.inputModel(
        //             //   "writeFunctionCode",
        //             //   params.row,
        //             //   "写功能码"
        //             // );
        //           },
        //         },
        //       },
        //       writeFunctionCode || "-"
        //     );
        //   },
        // },
        {
          title: "小数位数",
          key: "dataLen",
          width: 200,
          render: (h, params) => {
            const dataLen = params.row.dataLen;
            return h(
              "div",
              {
                on: {
                  click: () => {},
                },
              },
              dataLen || "-"
            );
          },
        },
        {
          title: "缩放因子",
          key: "scaling",
          width: 200,
          render: (h, params) => {
            const scaling = params.row.scaling;
            return h(
              "div",
              {
                on: {
                  click: () => {},
                },
              },
              scaling || "-"
            );
          },
        },
        {
          title: "数据转换参数b",
          key: "convertB",
          width: 200,
          render: (h, params) => {
            const convertB = params.row.convertB;
            return h(
              "div",
              {
                on: {
                  click: () => {},
                },
              },
              convertB || "-"
            );
          },
        },
        {
          title: "质量位",
          key: "isQuality",
          width: 200,
          render: (h, params) => {
            const isQuality = params.row.isQuality == 0 ? "否" : "是";

            return h(
              "div",
              {
                on: {
                  click: () => {},
                },
              },
              isQuality || "-"
            );
          },
        },

        {
          title: "质量位寄存器地址",
          key: "qualityRegisterAddress",
          width: 150,

          render: (h, params) => {
            const qualityRegisterAddress = params.row.qualityRegisterAddress;
            return h(
              "div",
              {
                on: {},
              },
              qualityRegisterAddress || "-"
            );
          },
        },
        {
          title: "质量位详情",
          key: "qualitys",
          width: 220,
          render: (h, params) => {
            const qualitys = params.row.qualitys;

            let str;
            if (qualitys) {
              str = Object.values(qualitys).toString();
            } else {
              str = "-";
            }

            return h(
              "div",

              {
                class: "line-2",
                style: {
                  width: "200px",
                },
                on: {},
              },
              str || "-"
            );
          },
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          width: 220,
          render: (h, params) => {
            const gmtCreate = params.row.gmtCreate;

            return h(
              "div",

              {
                class: "line-2",
                style: {
                  width: "200px",
                },
                on: {},
              },
              gmtCreate || "-"
            );
          },
        },

        {
          title: "操作",
          key: "address",
          align: "center",
          fixed: "right",
          width: 150,

          className: "action",
          render: (h, params) => {
            const item = params.row;
            let bo = true;

            let dshow = [];
            let btnarr = [];

            btnarr.push(
              h(
                "span",
                {
                  class: "anchorPoint-oilSite-list-edit pot",
                  attrs: {
                    id: `anchorPoint-oilSite-list-edit${params.index}`,
                  },
                  style: {
                    "text-align": "center !important",
                    "font-weight": "400",
                    color: "#0C479D",
                  },
                  on: {
                    click: (name) => {
                      this.editDetail(item);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  class: "anchorPoint-oilSite-list-edit pot",
                  attrs: {
                    id: `anchorPoint-oilSite-list-edit${params.index}`,
                  },
                  style: {
                    "text-align": "center !important",
                    "font-weight": "400",
                    color: "#0C479D",
                  },
                  on: {
                    click: (name) => {
                      this.delItemWarning(item);
                    },
                  },
                },
                "删除"
              )
            );

            return btnarr;
          },
        },
      ],
      showDrawer: false,
      timernum: 0,
      soikobj: {},
      zbiaoobj: {},
      zbtimernum: null,
      dataTypeoption: ["INT", "DOUBLE", "FLOAT", "TEXT", "DATE"],

      iconvisible: false,
      iconPopvisible: false,
      inputLoading: true,
      colorOption: [],
      utilOption: [],
    };
  },

  mounted() {
    this.getLists();
    this.init();
  },
  methods: {
    iconChange(row) {
      this.formData.keyname = row.key;
      this.formData.iconAlarmKey = row.iconAlarmKey;
      this.formData.iconNormalKey = row.iconNormalKey;
      this.formData.iconAbnormalKey = row.iconAbnormalKey;
      this.iconPopvisible = false;
    },
    QualityForm() {
      if (this.formData.isQuality == 1) {
        if (
          this.formData.qualitys == null ||
          this.formData.qualitys.length == 0
        ) {
          this.$Message.info("质量位详情最少为1个");
          return;
        }
      }

      this.upload(this.formData);
      this.cacel();
    },
    cacel() {
      this.formData = {};
      this.QualityShow = false;
      this.iconvisible = false;
      this.iconPopvisible = false;
    },
    changeMethods(index) {
      this.formData.qualitys = index;
      if (this.QualityShow) {
        //修改质量位
      } else {
        //直接修改详情
        this.$nextTick(() => {
          this.upload(this.formData);
        });
      }
    },
    // <Input
    //   style="width: 507px"
    //   v-model={formData.keyname}
    //   placeholder="请输入"
    // ></Input>
    setorderiCon(row) {
      let formData = { ...row };
      let imageOption = this.imageOption;

      let item = imageOption.find((e) => {
        const {
          iconAbnormalFullPath,
          iconAbnormalKey,
          iconAlarmFullPath,
          iconAlarmKey,
          iconNormalFullPath,
          iconNormalKey,
        } = e;

        if (
          iconAbnormalKey == formData.iconAbnormalKey &&
          iconAlarmKey == formData.iconAlarmKey &&
          iconNormalKey == formData.iconNormalKey
        ) {
          return true;
        }
      });
      if (item) {
        formData.keyname = item.key;
      }

      this.$nextTick(() => {
        this.formData = formData;
        this.iconvisible = true;
      });
    },
    // SelecttModel(text, row, title, cityList) {
    //   let zhuangzhiId = row[text];
    //   this.$Modal.confirm({
    //     render: (h) => {
    //       return [
    //         h(
    //           "div",
    //           {
    //             class: "dev-mo-config",
    //             attrs: {
    //               id: "dev-mo-config",
    //             },
    //           },
    //           [
    //             h(
    //               "div",
    //               {
    //                 class: "pro-model-title",
    //               },
    //               `编辑`
    //             ),
    //             [
    //               h(
    //                 "div",
    //                 {
    //                   class: "u-flex",
    //                   style: {
    //                     position: "relative",
    //                     top: "6px",
    //                   },
    //                 },
    //                 [
    //                   h(
    //                     "div",
    //                     {
    //                       class: "dev-normal",
    //                     },
    //                     `${title}`
    //                   ),
    //                   [
    //                     h(
    //                       "Select",
    //                       {
    //                         attrs: {
    //                           id: "dev-select",
    //                         },
    //                         style: {
    //                           with: "90%",
    //                         },
    //                         props: {
    //                           value: zhuangzhiId,
    //                         },
    //                         on: {
    //                           "on-change": (event) => {
    //                             zhuangzhiId = event;
    //                           },
    //                         },
    //                       },
    //                       cityList.map((item) => {
    //                         return h(
    //                           "Option",
    //                           {
    //                             props: {
    //                               value: item,
    //                             },
    //                           },
    //                           item
    //                         );
    //                       })
    //                     ),
    //                   ],
    //                 ]
    //               ),
    //             ],
    //           ]
    //         ),
    //       ];
    //     },
    //     onOk: () => {

    //       let row1 = { ...row };

    //       row1[text] = zhuangzhiId;

    //       this.upload(row1);
    //     },
    //   });
    // },
    SelecttModel(text, row, title, cityList) {
      let zhuangzhiId = row[text];
      this.$Modal.confirm({
        loading: this.inputLoading,
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-mo-config",
                attrs: {
                  id: "dev-mo-config",
                },
              },
              [
                h(
                  "div",
                  {
                    class: "pro-model-title",
                  },
                  `编辑`
                ),
                [
                  h(
                    "div",
                    {
                      class: "u-flex",
                      style: {
                        position: "relative",
                        top: "6px",
                      },
                    },
                    [
                      h(
                        "div",
                        {
                          class: "dev-normal",
                        },
                        `${title}`
                      ),
                      [
                        h(
                          "Select",
                          {
                            attrs: {
                              id: "dev-select",
                            },
                            style: {
                              with: "90%",
                            },
                            props: {
                              value: zhuangzhiId,
                            },
                            on: {
                              "on-change": (event) => {
                                zhuangzhiId = event;
                              },
                            },
                          },
                          cityList.map((item) => {
                            return h(
                              "Option",
                              {
                                props: {
                                  value: item,
                                },
                              },
                              item
                            );
                          })
                        ),
                      ],
                    ]
                  ),
                ],
              ]
            ),
          ];
        },
        onOk: () => {
          let row1 = { ...row };

          row1[text] = zhuangzhiId;

          this.upload(row1);
        },
      });
    },
    readio(text, row, title, bo = false) {
      let zhuangzhiId;
      let arr3 = [];

      let arr = [
        {
          value: 1,
          lable: "是",
        },
        {
          value: 0,
          lable: "否",
        },
      ];
      let arr1 = [
        {
          value: "需要差分",
          lable: "是",
        },
        {
          value: "0",
          lable: "否",
        },
      ];
      if (bo) {
        zhuangzhiId = row[text];
        arr3 = arr1;
      } else {
        zhuangzhiId = Number(row[text]);
        arr3 = arr;
      }
      this.$Modal.confirm({
        loading: this.inputLoading,
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-mo-config",
                attrs: {
                  id: "dev-mo-config",
                },
              },
              [
                h(
                  "div",
                  {
                    class: "pro-model-title",
                  },
                  `编辑`
                ),
                [
                  h(
                    "div",
                    {
                      class: "u-flex",
                      style: {
                        position: "relative",
                        top: "6px",
                      },
                    },
                    [
                      h(
                        "div",
                        {
                          class: "dev-normal",
                        },
                        `${title}`
                      ),
                      h(
                        "RadioGroup",
                        {
                          style: {
                            width: "90%",
                          },
                          props: {
                            value: zhuangzhiId,
                          },
                          on: {
                            "on-change": (event) => {
                              zhuangzhiId = event;
                            },
                          },
                        },
                        arr3.map((e) => {
                          return h(
                            "Radio",
                            {
                              props: {
                                label: e.value,
                              },
                            },
                            e.lable
                          );
                        })
                      ),
                    ]
                  ),
                ],
              ]
            ),
          ];
        },
        onOk: () => {
          let row1 = { ...row };

          row1[text] = zhuangzhiId;

          this.upload(row1);
        },
      });
    },

    inputModel(text, row, title) {
      let zhuangzhiId = row[text];
      this.$Modal.confirm({
        loading: this.inputLoading,
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-mo-config",
                attrs: {
                  id: "dev-mo-config",
                },
              },
              [
                h(
                  "div",
                  {
                    class: "pro-model-title",
                  },
                  `编辑`
                ),
                [
                  h(
                    "div",
                    {
                      class: "u-flex",
                      style: {
                        position: "relative",
                        top: "6px",
                      },
                    },
                    [
                      h(
                        "div",
                        {
                          attrs: {},
                          class: "dev-normal",
                          style: {
                            position: "absolute",
                            top: "-53px",
                            opacity: "0",
                          },
                          on: {
                            click: () => {
                              this.$nextTick(() => {
                                setTimeout(() => {
                                  this.$Modal.remove();
                                }, 300);
                              });
                            },
                          },
                        },
                        "1"
                      ),
                      h(
                        "div",
                        {
                          class: "dev-normal",
                        },
                        `${title}`
                      ),
                      h(
                        "div",
                        {
                          style: {
                            width: "90%",
                          },
                        },
                        [
                          h("Input", {
                            attrs: {
                              id: "dev-select",
                            },
                            style: {
                              with: "90%",
                            },
                            props: {
                              value: zhuangzhiId,
                            },
                            on: {
                              "on-blur": (event) => {
                                zhuangzhiId = event.target._value;
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
              ]
            ),
          ];
        },
        onOk: () => {
          let row1 = { ...row };

          row1[text] = zhuangzhiId;

          this.upload(row1);
        },
      });
    },
    async upload(row) {
      identifierIconUpdate({ ...row }).then((data) => {
        this.inputLoading = false;
        try {
          if (data.code == "00000") {
            this.$Message.success("操作成功");
            this.$Modal.remove();
            this.getLists();
          }
        } catch (error) {
          const footerElement = document.querySelector(
            ".ivu-modal-confirm-footer"
          );
          const loadingButtonElement =
            footerElement.querySelector(".ivu-btn-loading");

          const loadLoopElement =
            loadingButtonElement.querySelector(".ivu-load-loop");

          loadLoopElement.parentNode.removeChild(loadLoopElement);
          loadingButtonElement.classList.remove("ivu-btn-loading");
        }
        //
      });
    },
    getColors() {
      return new Promise((resolve, reject) => {
        oliSiteIdefierColos().then((data) => {
          console.log("data", data);
          resolve(data.data);
        });
      });
    },
    async init() {
      if (!this.userRole.includes("a")) {
        let data1 = await olitypelist({
          current: 1,
          id: "",
          identifiers: [],
          name: "",
          size: 100,
        });

        this.cityList = data1.data.records.map((e) => {
          e.value = e.name;
          return e;
        });
      }
      let listdata = await oliSiteIdefierUntis();

      // let colotsList = await oliSiteIdefierColos();
      // this.colorOption = colotsList.data;
      this.colorOption = await this.getColors();
      this.utilOption = listdata.data;

      //  let timernum
      let userRole = this.userRole;
      let item = this.sockedlist.find((e) => e.type == "oil");
      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);
      this.dataColumn = this.dataColumn.map((item) => {
        if (item.title == "操作") {
          if (userRole.includes("a") || userRole.includes("c0")) {
            item.width = 100;
          }
        }
        return item;
      });
      identifierIcon().then((data) => {
        this.imageOption = data.data;
      });
    },
    clearmodel() {
      this.modal1 = false;
    },
    Onecliccopy() {
      const { oilSiteTypeId, oilSiteIotName, secret } = this.modeobj;
      let text = `
        {
          "iotProductKey":${oilSiteTypeId},
          "DeviceName":${oilSiteIotName},
          "DeviceSecret":${secret}
        }
        `;
      this.copy(text);
    },
    copy(text) {
      let that = this;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          function () {
            that.$Message.success("复制成功");
          },
          function () {
            //	copy2(text);
          }
        );
      } else {
        //	copy2(text);
      }
    },

    delItemWarning(item) {
      this.$Modal.confirm({
        title: `您确定要删除该点表？`,
        content: `点表标识：${item.identifier}`,

        onOk: () => {
          this.delItem(item.id);
        },
        onCancel: () => {},
      });
    },
    delItem(id) {
      identifierIconDelete({ id }).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("删除成功");
          this.curItemDetail = {};
          const finalSize = this.sizeData(
            this.pageInfo.size,
            this.pageInfo.current,
            this.pageInfo.total
          );
          this.getLists(finalSize);
        }
      });
    },
    async getLists(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理

      siteidentifiergetPage({
        ...this.pageInfo,
        ...this.dataForm,
      }).then((res) => {
        if (res.code === "00000") {
          const datas = res.data;
          this.dataLists = datas.records;

          this.pageInfo.total = datas.total;
          setTimeout(() => {
            this.$store.state.spinShow = false;
          }, 500);
        }
      });
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getLists(1);
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeSel(val, name, arr) {
      //选择离线-清空报警状态

      this.selItems = this.handleSelItem(val, name, arr, "lable", "value");

      this.getLists(1);
    },
    changeDate(date, name) {
      this.dataForm.gmtCreateDateStart = date[0];
      this.dataForm.gmtCreateDateEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      this.dataForm[selItem.name] = null;

      //日期需要单独处理
      if (selItem.name === "date") {
        delete this.dataForm.gmtCreateDateStart;
        delete this.dataForm.gmtCreateDateEnd;
      }

      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    async added() {
      this.curItemDetail = {};
      this.colorOption = await this.getColors();
      this.$nextTick(() => {
        setTimeout(() => {
          this.showDrawer = true;
        }, 300);
      
      });
    },
    async editDetail(item) {
      this.colorOption = await this.getColors();
      this.curItemDetail = deepcopy({...item, offset: `${item.offset}`});
      this.showDrawer = true;
    },
    async closeDrawer() {
      this.showDrawer = false;

      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.curItemDetail = {};
      });
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
  },
};
</script>
<style>
.transfer-class-name {
}
.transfer-class-name .ivu-icon {
  z-index: 1;
}

.transfer-class-name .ivu-btn-primary {
  color: #fff !important;
  background-color: #0c479d !important;
  border-color: #0c479d !important;
  height: 24px !important;
  padding: 0 7px !important;
  font-size: 14px !important;
  border-radius: 3px !important;
}
.lineColor .ivu-dropdown-menu {
  min-width: 90px;
}
.pointemitfont {
  color: #0070cc;
  cursor: pointer;
  position: absolute;
  top: -33px;
  left: 85px;
}
</style>


<style lang="less">
//  .ivu-select-dropdown{
//     left: 12px !important;
//   }
.rhicon-img {
  width: 16px;
  height: 16px;
  /* margin-top: 3px; */
  position: relative;
  top: 3.5px;
}

.equipmentTable {
  .ivu-table-tbody {
    td {
      padding: 10px 0;

      .ivu-table-cell {
        span {
          font-size: 14px;
        }
      }
    }

    .ivu-btn {
      &:hover {
        border: 1px solid #ccc;
      }
    }
  }
}

.modu-copy {
  color: #2d8cf0;
  margin-left: 10px;
  font-size: 12px;
}

.mod-left {
  width: 90px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
}

.mod-right {
  font-size: 12px;
  color: #000;
  margin-left: 30px;
  display: flex;
}
.pro-model-title {
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  position: relative;
  top: -6px;
}
.pro-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
</style>